export default "__VITE_ASSET__51076c85__"